// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

var Types = {};

var fragmentConverter = {"__root":{"":{"f":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

var Utils = {};

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditMarketingProfileMember_page_marketingProfileMember",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditMarketingProfileMember_header_marketingProfileMember"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditMarketingProfileMemberInfoForm_marketingProfileMember"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MarketingProfileMemberPhotoForm_agentMarketingProfile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditMarketingProfileMemberSocialAccountsForm_marketingProfileMember"
    }
  ],
  "type": "MarketingProfileMember",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
